<div class="mappings p-1">
  <div class="d-flex justify-content-between align-items-start">
    <mat-form-field>
      <mat-select [disabled]="!isProcessSelected" placeholder="Select document type" (selectionChange)="onSelectDocumentType($event.value)" [(value)]="selectedDocumentTypeId">
        <mat-option [value]="option.ID" *ngFor="let option of documentTypes">{{option.Name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button [disabled]="!isProcessSelected" mat-raised-button color="warn" class="mt-2" (click)="onReset()">Reset</button>
  </div>

  <div class="mappings-container" *ngIf="isProcessSelected">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef> Source </th>
        <td mat-cell *matCellDef="let element" class="col-m-w ellipsis" title="{{element.Name}}"> {{element.Name}} </td>
      </ng-container>

      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef> Destination </th>
        <td mat-cell *matCellDef="let element" class="col-m-w ellipsis" title="{{element.Destination}}"> {{element.Destination}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td class="text-right" mat-cell *matCellDef="let element">
          <mat-icon class="v-align-middle fill-primary cursor-pointer mr-2" svgIcon="edit_ico" (click)="onEdit(element)"></mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
